<!-- 板子厚度 -->
<template>
  <BaseFormItem2
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <BaseRadioGroup2 v-model="val" :isError="isError" @change="handleEmit">
      <BaseTipPopover 
        v-for="item in options"
        :key="item.value" 
        :content="item.tips" 
        :disabled="!item.tips"
      >
        <el-radio-button
          slot="reference"
          :label="item.value"
          :disabled="item.disabled"
        >
          {{ { 1: '1.0', 2: '2.0' }[item.label] || item.label }}
        </el-radio-button>
      </BaseTipPopover>
    </BaseRadioGroup2>
  </BaseFormItem2>
</template>

<script>
import { getROGERSFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: Number,
      default: 0.508
    },
    // 板子层数
    blayer: {
      type: Number,
      default: 2
    },
    // 板材型号
    board_model: {
      type: String,
      default: '4350B'
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    },
    // 获取配置的默认初始化参数中
    initDefaultPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value,
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getROGERSFields('bheight')
    },
    options() {
      const { val, blayer, board_model, fields } = this
      const options = {
        2: { 
          '4350B': [0.254, 0.338, 0.508, 0.762, 1.524],
          '4003C': [0.203, 0.508, 0.813, 1.524],
        }[board_model],
        4: [0.6, 0.8, 1.0, 1.2, 1.6, 2.0, 2.4],
        6: [1.0, 1.2, 1.6, 2.0, 2.4]
      }[blayer] || []

      if (!options.includes(Number(val))) {
        const defaultVal = { 2: 0.508, 4: 1.6, 6: 1.6 }[blayer]
        this.changeVal(defaultVal)
      }

      return fields.options.filter(item => options.includes(item.value))
    }
  },
  watch: {
    value(newVal) {
      this.val = +newVal
    }
  },
  methods: {
    handleEmit() {
      const { val, value } = this
      this.$emit('input', val)
      if (val != value) {
        this.$emit('change', val)
      }
      this.isShowError(false)
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      this.$topWarning.mergeFields(this.fields.label)
      this.val = val
      this.handleEmit()
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>